export interface DynamicConfig {
  apiBaseUrl: string
  clientId: string
  authority: string
  environment: string
  redirectUri: string
  scopes: string[]
  publicKey: string
}

// Replace these with your own clientId and TenantID
const clientID = 'e25a37e2-3736-4397-a039-0dc293a7aece'
const tenantId = '2e319086-9a26-46a3-865f-615bed576786'
const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAid+qSXVh9yhgA8Ve+L93
9QeWq2zbtUVxO3nqafnIT+2vCtqfnJJYlQZa0IoLcKK3XeovWy5MUeRoqrL9hb6X
mjHWZFC67YtnOBBylZxDWrb+VarSmiXhYm0HQVxHiau10FlKcoN8/rUprfT1lhNa
xMuM8nb5CIiGvAc36HAqENFPFNO74mN6ggWGOxMKwq4NShR6lPhVqQVS7z06M7Z5
sXKwhxFpeQNDp5Bj7PNbsNIwA2uUDETBrCToJ0x4qvZ/PoP7frPm6UTkxpoLeBGy
NxG0H/2VVihhQWfyckDusSG9pbTjhj8VIjRXra3yHKpOb0afbjZsKT/R0j0sIEkx
eQIDAQAB
-----END PUBLIC KEY-----`
export const apiScope = 'api://e25a37e2-3736-4397-a039-0dc293a7aece/Read'

export const defaultConfig: DynamicConfig = {
  apiBaseUrl: 'https://app-peer2peer-dev-api.azurewebsites.net',
  environment: 'dev',
  clientId: clientID,
  scopes: ['User.Read', 'User.Read.All', apiScope],
  redirectUri: 'http://localhost:3000/',
  authority: 'https://login.microsoftonline.com/' + tenantId,
  publicKey: publicKey,
}

class GlobalConfig {
  config: DynamicConfig = defaultConfig
  notDefinedYet = true

  public get(): DynamicConfig {
    if (this.notDefinedYet) {
      throw new Error(
        'Global config has not been defined yet. Be sure to call the getter only after the config has been downloaded and set. Probable cause is accessing globalConfig in static context.'
      )
    } else {
      return this.config
    }
  }

  public set(value: DynamicConfig): void {
    if (this.notDefinedYet) {
      this.config = value
      this.notDefinedYet = false
    } else {
      throw new Error(
        'Global config has already been defined and now has been called second time. This is probably not intended.'
      )
    }
  }
}

export const globalConfig = new GlobalConfig()

export const globalConfigUrl = 'appConfiguration.json'
